import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiGrowlComponent } from './eui-growl.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiGrowlComponent],
    declarations: [EuiGrowlComponent]
})
export class EuiGrowlComponentModule {
}
